module.exports = __webpack_public_path__ + "static/media/tl.a9687d3e.svg";